import { FC } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import './PreRegistrationLayout.scss';
import { LogoColor } from '@assets/images';

const PreRegistrationLayout: FC = () => {
  const location = useLocation();
  const isPolicyPage = location.pathname.includes('policy');
  return (
    <div className='PreRegisterLayout'>
      {isPolicyPage && (
        <div className='logoNabla'>
          <img className='authLogo' src={LogoColor} alt='Logo' />
        </div>
      )}

      {/* CONTENT */}
      <div className='PreRegisterLayout__content'>
        <Outlet />
      </div>
    </div>
  );
};

export default PreRegistrationLayout;
